import React from "react";

import Layout from "../../components/reusable/Layout";
import Pillar from "./Pillar";

import classes from "./PillarsOfLongevityPage.module.css";

import longevityMale from "../../images/pillars/longevityMale.png";
import longevityFemale from "../../images/pillars/longevityFemale.png";
import weightLossMale from "../../images/pillars/weightLossMale.png";
import weightLossFemale from "../../images/pillars/weightLossFemale.png";
import performanceMale from "../../images/pillars/performanceMale.png";
import performanceFemale from "../../images/pillars/performanceFemale.png";
import restoreUnisex from "../../images/pillars/restoreUnisex.png";
// @ts-ignore
import retoImage from "../../images/reto/pillars_image_reto.jpeg";
import naturalSlimPilarPage from "../../images/pillars/naturalSlimPilarPage.png";
import { fourthStreetMedicalPillarsImg } from "../../images/4thStreetMedical";

type PillarProps = {
  DESCRIPTION: string;
  ICON: string;
  INDEX: number;
  TITLE: string;
};

interface Props {
  data: {
    DESCRIPTION: string;
    INDEX: number;
    PILLARS: PillarProps[];
    TITLE: string;
  };
  gender: string;
  reportType: string;
  isRestoreReport?: boolean;
  isRetoReport?: boolean;
  isNaturalSlimReport?: boolean;
  isEvityReport?: boolean;
  isFourthStreetMedical?: boolean;
}

const PillarsOfLongevityPage = React.memo(
  ({
    data,
    gender,
    reportType,
    isRestoreReport,
    isRetoReport,
    isNaturalSlimReport,
    isEvityReport,
    isFourthStreetMedical,
  }: Props): JSX.Element => {
    let addedReportsPillars;
    // SD-3924 Remove "Gut" pillar from performance report type
    // if (reportType === "14" || reportType === "15") {
    //   addedReportsPillars = (
    //     <div className={classes.pillarsSection}>
    //       {data.PILLARS.slice(4).map((pillar) => (
    //         <Pillar key={pillar.INDEX} data={pillar} />
    //       ))}
    //     </div>
    //   );
    // } else {
    addedReportsPillars = (
      <div className={classes.pillarsSectionCenter}>
        {data.PILLARS.slice(4, -1).map((pillar) => (
          <Pillar key={pillar.INDEX} data={pillar} />
        ))}
      </div>
    );
    // }
    const backgroundImgHandler = (type: string, gender: string): string => {
      let backgroundImg: string;

      if (isRetoReport) {
        return retoImage;
      }

      if (isFourthStreetMedical) {
        return fourthStreetMedicalPillarsImg(type, gender);
      }

      switch (type) {
        case "naturalSlim":
          backgroundImg = naturalSlimPilarPage;
          break;
        case "restore":
          backgroundImg = restoreUnisex;
          break;
        case "10":
        case "11":
          backgroundImg = gender === "Female" ? longevityFemale : longevityMale;
          break;
        case "12":
        case "13":
          backgroundImg =
            gender === "Female" ? weightLossFemale : weightLossMale;
          break;
        case "14":
        case "15":
          backgroundImg =
            gender === "Female" ? performanceFemale : performanceMale;
          break;
        default:
          backgroundImg = longevityMale;
      }
      return backgroundImg;
    };

    const brainPillar = data.PILLARS.find((p) => p.ICON === "mental.png");
    const heartPillar = data.PILLARS.find((p) => p.ICON === "heart.png");
    const lungsPillar = data.PILLARS.find((p) => p.ICON === "lung.png");
    const spinePillar = data.PILLARS.find((p) => p.ICON === "posture.png");
    const cellPillar = data.PILLARS.find((p) => p.ICON === "cellular.png");

    return (
      <Layout customPadding={0} isEvityReport={isEvityReport}>
        <img
          className={classes.backgroundImg}
          src={backgroundImgHandler(
            isRestoreReport
              ? "restore"
              : isNaturalSlimReport
              ? "naturalSlim"
              : reportType,
            gender
          )}
          style={isRetoReport ? { width: "1622px", marginLeft: "-420px" } : {}}
          alt="background img per category"
        />
        <div className={classes.header}>
          <div
            className={classes.title}
            style={{
              color:
                isFourthStreetMedical ||
                isRestoreReport ||
                isRetoReport ||
                isNaturalSlimReport
                  ? "var(--primary100)"
                  : "var(--primary1000)",
            }}
          >
            {data.TITLE}
          </div>
        </div>
        <div className={classes.mainContent}>
          {/* Brain/Estado Mental - Top */}
          {brainPillar && (
            <div className={classes.pillarBrain}>
              <Pillar data={brainPillar} />
            </div>
          )}

          {/* Heart/Salud Cardiovascular - Right */}
          {heartPillar && (
            <div className={classes.pillarHeart}>
              <Pillar data={heartPillar} />
            </div>
          )}

          {/* Lungs/Salud Pulmonar - Left */}
          {lungsPillar && (
            <div className={classes.pillarLungs}>
              <Pillar data={lungsPillar} />
            </div>
          )}

          {/* Spine/Postura - Right Lower */}
          {spinePillar && (
            <div className={classes.pillarSpine}>
              <Pillar data={spinePillar} />
            </div>
          )}

          {/* Cell/Rendimiento Celular - Bottom */}
          {cellPillar && (
            <div className={classes.pillarCell}>
              <Pillar data={cellPillar} />
            </div>
          )}
        </div>
      </Layout>
    );
  }
);

export default PillarsOfLongevityPage;
